import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "../ui/alert-dialog";

export const ConfirmDelete = ({ open, title, onCancel, onConfirm }) => (
  <AlertDialog open={open} onOpenChange={(v) => !v && onCancel()}>
    <AlertDialogContent className="rounded-3xl" data-testid="confirm-delete-dialog">
      <AlertDialogHeader>
        <AlertDialogTitle>Silmek istediğinize emin misiniz?</AlertDialogTitle>
        <AlertDialogDescription>"{title}" kalıcı olarak silinecek.</AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter>
        <AlertDialogCancel className="rounded-full" data-testid="confirm-delete-cancel">Vazgeç</AlertDialogCancel>
        <AlertDialogAction onClick={onConfirm} className="rounded-full bg-red-600 hover:bg-red-700" data-testid="confirm-delete-ok">Evet, sil</AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
);
